import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.auth.SignupLoginModule.LoginModule', {
    emailRequired: 'Your email address is required.',
    emailInvalid: 'The email address is not valid.',
    passwordRequired: 'Password is required',
    loginButtonText: 'Log in',
    recoverPasswordButtonText: 'Forgot password?',
});
